import { memo } from "react";

import { Image } from "@/components/ui/image/image";
import { Label } from "@/components/ui/label/label";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

type Props = {
	title: string;
	categoryLabel: string;
	thumbnailUrl: string | null;
	isNew: boolean;
	onClick: () => void;
};

export const ArticlePreview = memo(({ title, categoryLabel, thumbnailUrl, isNew, onClick }: Props) => {
	return (
		<div role="button" className="group min-w-[300px] space-y-2" onClick={onClick}>
			<Image
				className="aspect-video h-40 w-full rounded border border-zinc-100 object-cover"
				src={thumbnailUrl ?? DUMMY_IMAGE.url}
				alt={`${title}のサムネイル`}
			/>
			<div className="space-y-2">
				<div className="flex items-center gap-x-2">
					{isNew && <Label text="NEW" variant="pink" size="sm" />}
					<Label text={categoryLabel} variant="black" size="sm" />
				</div>
				<p className="line-clamp-3 break-all group-hover:underline group-hover:underline-offset-4">{title}</p>
			</div>
		</div>
	);
});
